<template>
        <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
            <div class="kt-portlet kt-portlet--mobile" id="tableDiv">
                <div v-if="!showDialogFilters" class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                    <app-filter-bar @datesAndFiltersHandler="validateDataPreRequest"
                                    :filter_button_is_loading="isLoadingHistoricalData"
                                    :selected-vehicles-prop="selectedVehicles"
                                    :show_historical_data="showHistoricalData"
                                    :feature="'TRACK'"
                                    :show_vehicle_type="true"
                                    :show_panel="showPanel"
                                    @vehiclesChanged="vehiclesChanged"
                                    @selectedVehiclesChanged="selectedVehiclesChanged"
                                    @selectedOrganizationsChanged="selectedOrganizationsChanged"
                                    ref="filterBar">

                        <template v-slot:slot-two>
                            <app-button v-show="showHistoricalData"
                                        :disabled="isLoadingHistoricalData"
                                        type="danger"
                                        class="auto-center"
                                        style="margin-left: 5px"
                                        @handleClick="handleBackToRealTime"> {{ $t('AppVehiclesTrack.Voltar') }}
                            </app-button>

                            <select v-show="showHistoricalData"
                                    style="width: 110px"
                                    class="form-control kt-margin-5-desktop width-auto auto-center"
                                    @change="handleChangeWorkType($event)"
                                    v-model="optionsSelectWorkTypeSelected">
                                <option v-for="option in optionsSelectWorkType" v-bind:key="option.key"
                                        :value="option">
                                    {{ option.value }}
                                </option>
                            </select>

                            <app-button v-show="showHistoricalData && historicalChartsData.length > 0"
                                        :disabled="loadingReport"
                                        type="secondary"
                                        class="auto-center"
                                        style="margin-left: 15px"
                                        @handleClick="requestPDFReport">

                                {{ $t('AppVehiclesTrack.Relatório') }}
                            </app-button>

                            <div v-show="showManualDownloadButton && !showHistoricalData" @click="handleDownloadManual"
                                 v-tooltip.bottom="$t('AppVehiclesTrack.Manual do Usuário')"
                                 class="text-center button-graphics auto-center manual-download-button ml-auto">
                                <i v-show="!loadingManualDownload" class="pi pi-file-pdf icon-graphic"></i>
                                <i v-show="loadingManualDownload" class="pi pi-spin pi-spinner icon-graphic"></i>
                            </div>
                        </template>
                    </app-filter-bar>

                </div>
                <div v-if="showDialogFilters" class="kt-portlet__head kt-portlet__head--lg no-border-radius" style="justify-content: center;">
                    <app-button v-show="showDialogFilters" type="primary" class="mx-1 auto-center"
                                @handleClick="openMaximizable"
                                :class="{ 'kt-spinner kt-spinner--v2 kt-spinner--right kt-spinner--sm kt-spinner--dark': isLoadingHistoricalData }">
                        {{ $t('AppVehiclesTrack.Filtrar') }}
                    </app-button>
                    <app-button v-show="showHistoricalData"
                                :disabled="isLoadingHistoricalData"
                                type="danger"
                                style="margin-left: 5px;"
                                class="auto-center"
                                @handleClick="handleBackToRealTime">{{ $t('AppVehiclesTrack.Voltar') }}
                    </app-button>
                    <app-button v-show="showHistoricalData && historicalChartsData.length > 0"
                                :disabled="loadingReport"
                                type="secondary"
                                class="auto-center"
                                style="margin-left: 7px"
                                @handleClick="requestPDFReport">
                        {{ $t('AppVehiclesTrack.Relatório') }}
                    </app-button>

                    <div v-show="showManualDownloadButton && !showHistoricalData" @click="handleDownloadManual"
                         v-tooltip.bottom="$t('AppVehiclesTrack.Manual do Usuário')"
                         class="text-center button-graphics auto-center manual-download-button"
                         style="margin-left: 7px">
                        <i v-show="!loadingManualDownload" class="pi pi-file-pdf icon-graphic"></i>
                        <i v-show="loadingManualDownload" class="pi pi-spin pi-spinner icon-graphic"></i>
                    </div>
                </div>
                <Dialog :header="$t('AppVehiclesTrack.Filtrar')" :visible.sync="displayMaximizable" :containerStyle="{width: '85vw'}" :maximizable="true" :modal="true">
                    <app-filter-bar @datesAndFiltersHandler="validateDataPreRequest"
                                    :is_col_12="true"
                                    :filter_button_is_loading="isLoadingHistoricalData"
                                    :selected-vehicles-prop="selectedVehicles"
                                    :show_historical_data="showHistoricalData"
                                    :feature="'TRACK'"
                                    @vehiclesChanged="vehiclesChanged"
                                    @selectedVehiclesChanged="selectedVehiclesChanged"
                                    @selectedOrganizationsChanged="selectedOrganizationsChanged"
                                    ref="filterBar"/>
                </Dialog>
                <div class="kt-portlet__body no-padding">

                    <splitpanes class="default-theme" :class="{'splitpanes-height': !is_col_12}"
                                :dbl-click-splitter="false"
                                @resize="splitPanesResized"
                                @resized="splitPanesResized" :horizontal="is_col_12">
                        <pane min-size="1" :size="paneSize">
                            <div class="row no-gutters" :class="{'wraper height-maps': !is_col_12,
                                    'height-maps-open': is_col_12 && !showRightPaneCharts, 'height-maps-close': is_col_12 && showRightPaneCharts}">
                                <div class="col-12">

                                    <!--Select com o estados das maquinas-->
                                    <!--                                    <div style="position: absolute; z-index: 10; left: 20px; top: 10px"-->
                                    <div style="position: absolute; z-index: 10; left: 10px; top:10px"
                                         v-show="paneSize > 25 && !showHistoricalData">
                                        <app-vehicles-status-control
                                            @statusChanged="statusChanged">

                                        </app-vehicles-status-control>
                                    </div>

                                    <div style="position: absolute; z-index: 5; top: 1px; pointer-events: none;"
                                         v-if="showHistoricalData && !is_col_12">
                                        <app-historical-map-overlay
                                            :cards="cards"
                                            :subtitle="optionsSelectWorkTypeSelected ? optionsSelectWorkTypeSelected.value : ''"/>
                                    </div>

                                    <!--Select com os tipos de mapa-->
                                    <div style="position: absolute; z-index: 10; top: 10px; right: 20px"
                                         v-show="paneSize > 20">
                                        <div class="row justify-content-center">

                                            <app-google-maps-type-control
                                                :show_work_details="showHistoricalData"
                                                ref="googleMapsTypeControl"
                                                @handleMapControlClick="handleMapControlClick">
                                            </app-google-maps-type-control>
                                        </div>
                                    </div>

                                    <div
                                        class="position-bottom"
                                        v-show="paneSize > 25">
                                        <div class="row justify-content-center">
                                            <app-google-maps-legend :there_is_work_track_data="thereIsWorkTrackData"
                                                                    :there_is_idle_track_data="thereIsIdleTrackData"
                                                                    :there_is_maneuver_track_data="thereIsManeuverTrackData"
                                                                    :there_is_travel_track_data="thereIsTravelTrackData"
                                                                    :show_at_real_time="!showHistoricalData"/>
                                        </div>
                                    </div>
                                    <div
                                        style="position: absolute; z-index: 5; bottom: 1px;  width: 99%; margin: 0 auto;">
                                        <div class="row" style="float: right">
                                            <app-google-maps-weather-legend
                                                :show_legend="weather_overlay">
                                            </app-google-maps-weather-legend>
                                        </div>
                                    </div>
                                    <app-google-maps-real-time
                                        ref="googleMapsRealTime"
                                        :org_zone="orgZone"
                                        :vehicles_list="vehicles"
                                        :selected_organization_id="selectedOrganizationId"
                                        :selected_vehicles="selectedVehicles"
                                        :realtime_data="realtimeDataMarkers"
                                        :map_type="mapsTypesSelected"
                                        :show_panel="showPanel"
                                        :selected_statuses="vehiclesStatusesSelected"
                                        :positionCenter="center"
                                        :tilesData="tilesData"
                                        :weather_overlay="weather_overlay"
                                        :organization_identification="organizationSelected"
                                        :selected_organizations="selectedOrganizations"
                                        :marker_historical="marker_historical"
                                        :marker_location="markerLocation"
                                        :pbf_tiles_data="pbfTilesData"
                                        :track_on="trackOn"
                                        :report_dates="reportDates"
                                        :display_id_vehicles="displayIdVehicles"
                                        :marker_init_data="markerInitData"
                                        :marker_end_data="markerEndData"
                                        :gaps="gaps"
                                        :noTrackOn="noTrackOn"
                                        :historical_charts_data="historicalChartsData"
                                        :connectivity_events="connectivityEvents"
                                        style="position: relative; width: 100%; height: 100%"
                                        class="google-maps"
                                        @handleClickMarker="handleClickMarker"
                                        @handleClickCloseInfoWindow="handleClickCloseInfoWindow"
                                        @handleZoomChanged="handleZoomChanged"
                                        @handleBoundsChanged="handleBoundsChanged"
                                        @updateVehiclesIdsInVisibleCluster="updateVehiclesIdsInVisibleCluster"/>
                                    <div v-if="showMapOverlay && !showHistoricalData && selectedOrganizations.length > 0 && !is_col_12"
                                            style="position: absolute; z-index: 5; top: 1px; width: 99%; margin: 0 auto; pointer-events: none;">
                                        <app-dashboard-map-overlay
                                            :map_overlay_data="map_overlay_data"
                                            :fleet_status="fleet_status"
                                            :idle_machines="idle_machines"
                                            :fuel_level="fuel_level"
                                            :maintenance_machines="maintenance_machines" />
                                    </div>
                                    <div style="position: absolute; z-index: 5; bottom: 1px; width: 99%; margin: 0 auto;">
                                        <div class="row" style="float: right; width: 150px;position:absolute; bottom:5px; right:5px;">
                                            <img src="../../../assets/images/brands/poweredByIotag.png" class="img-fluid">
                                        </div>
                                        <div class="line" :class="{'active': locationOn}" :style="{bottom: bottomButton}" style="float: right;position:relative;">
                                            <div :class="{'item-active': locationOn, 'item': !locationOn}" @click="handleMapControlClick('location')">
                                                <img src="@/assets/images/maps-type-control/location.png" alt="">
                                            </div>
                                        </div>
                                        <div class="line" :class="{'active-panel': showPanel}" :style="{bottom: bottomButtonPanel}" style="float: right;position:relative; left: 35px;">
                                            <div v-if="showPanelStatus" @click="handleShowDetails()">
                                                <i style="color: white;" class="pi pi-eye icon-eye"></i>
                                            </div>
                                            <div v-else @click="handleShowDetails()">
                                                <i style="color: black;" class="pi pi-eye-slash icon-eye"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </pane>

                        <pane min-size="1" v-if="showRightPaneCharts" :size="100 - paneSize">
                            <app-charts-right-side
                                ref="chartsRightSide"
                                :org_zone="orgZone"
                                :events-report-clustered="eventsReportClustered"
                                :eventsReport="eventsReport"
                                :selectedVehicles="selectedVehicles"
                                :realtimeChartsData="realtimeChartsData"
                                :vehicles="vehicles"
                                :historicalChartsData="historicalChartsData"
                                :historicalPieChartsData="historicalPieChartsData"
                                :showHistoricalData="showHistoricalData"
                                :itemsCharts="100 - paneSize"
                                :hour_meter_series="hourMeterSeries"
                                @customMouseOver="customMouseOver"
                                @mouseOverEvent="mouseOverEvent">
                            </app-charts-right-side>
                        </pane>
                    </splitpanes>
                </div>
            </div>

        <app-vehicles-new-selection-dialog :display_dialog="showNewVehiclesSelectionDialog"
                                           @handleClose="handleCloseNewSelectionDialog"/>
        <app-real-time-report ref="report"
                              :org_zone="orgZone"
                              :selected_vehicles="selectedVehicles"
                              :events="eventsReport"
                              :cards_data="cardsData"
                              :historical_pie_charts_data="historicalPieChartsData"
                              :report_dates="reportDates"
                              @reportHasBeenDownloaded="reportHasBeenDownloaded"/>
        </div>
</template>

<script>

    import {Splitpanes, Pane} from 'splitpanes'
    import 'splitpanes/dist/splitpanes.css'

    import AppFilterBar from '../../common/AppFilterBar';
    import {formatHours, formatSecondsAsHours} from "@/utils/hourFormat";
    import {MODE, countableEvents, eventsByMode, fuelByMode, monitoredPeriod, normalizeEvents, summarize, timeByMode, totalFuel} from "@/utils/indicators";
    import AppVehiclesSelectVehicles from "./AppVehiclesSelectVehicles";
    import AppDateTimeControlBar from "../../common/AppDateTimeControlBar";

    import AppGoogleMapsLegend from "../../common/AppGoogleMapsLegend";
    import AppGoogleMapsRealTime from "./AppGoogleMapsRealTime";
    import AppGoogleMapsTypeControl from "@/components/common/AppGoogleMapsTypeControl";
    import AppGoogleMapsWeatherLegend from "./AppGoogleMapsWeatherLegend";
    import AppVehiclesStatusControl from "./AppVehiclesStatusControl";
    import AppVehiclesNewSelectionDialog from "./AppVehiclesNewSelectionDialog";
    import AppDashboardMapOverlay from './AppDashboardMapOverlay.vue';


    import AppChartsRightSide from "./AppChartsRightSide";
    import AppHistoricalMapOverlay from "./AppHistoricalMapOverlay.vue";

    import Button from 'primevue/button';
    import AppButton from "../../common/AppButton";
    import MultiSelect from 'primevue/multiselect';
    import Dropdown from 'primevue/dropdown';
    import Dialog from 'primevue/dialog';

    import {MAPS_OVERLAY_WORK_TYPES, VEHICLES_STATUSES_LIST} from './AppOptions';
    import {OPTIONS_SELECT_WORK_TYPE} from './AppOptions';

    import RealtimeService from '../../../services/RealtimeService';
    import TrackService from "../../../services/TrackService";
    import VehiclesService from "../../../services/VehiclesService";
    import FieldsService from "../../../services/FieldsService";
    import ReportsService from "../../../services/ReportsService";
    import MapOverlayService from "../../../services/MapOverlayService";
    import OrganizationsService from "../../../services/OrganizationsService";
    import hasFeatureEnabled from "@/mixins/OrganizationFeatureFlagsMixin";
    import isInSeconds from "@/mixins/VehicleMarkerMixin";
    import getMinutesFromSecondsDurationFormatMixin from "@/mixins/DateMixin";

    import {MAPS_OVERLAY_OPEN_WEATHER_TYPES} from './AppOptions';
    import {MAPS_OVERLAY_WEATHER_TYPES} from './AppOptions';
    import {MAPS_DEFAULT_CONFIGS} from './AppOptions';

    import moment from 'moment-timezone';

    import AppRealTimeReport from "@/components/views/real-time/report/AppRealTimeReport";
    import {router} from "@/router";
    import * as htmlToImage from "html-to-image";

    export default {
        mixins: [hasFeatureEnabled, isInSeconds, getMinutesFromSecondsDurationFormatMixin],
        created() {
            window.addEventListener('keydown', this.keyF11);
        },
        beforeMount() {
            if (!this.hasFeatureEnabled("TRACK")) {
                router.push({name: 'profile'});
                return;
            }
            this.retrievePaneSize();
        },
        mounted() {
            this.mapsTypesSelected = this.mapsTypes[1].value;
            this.realtimeService = new RealtimeService();
            this.trackService = new TrackService();
            this.optionsSelectWorkTypeSelected = this.optionsSelectWorkType[0];
            this.vehiclesService = new VehiclesService();
            this.fieldsService = new FieldsService();
            this.reportsService = new ReportsService();
            this.mapOverlayService = new MapOverlayService();
            this.showDialogFilters = this.isScreenMobile;
            this.is_col_12 = this.isScreenMobile;
            this.bottomButton = this.isScreenMobile ? '105px' : '50px';
            this.bottomButtonPanel = this.isScreenMobile ? '155px' : '105px';
            this.organizationsService = new OrganizationsService();
            this.checkShowManualDownloadButton();
        },

        data() {
            return {
                reportsService: null,
                showDialogFilters: false,
                is_col_12: false,
                displayMaximizable: false,
                bottomButtonPanel: null,
                bottomButton: null,
                markerLocation: null,
                trackService: null,
                realtimeService: null,
                vehiclesService: null,
                fieldsService: null,
                showPanel: false,
                showPanelStatus: false,

                locationOn: false,
                showFields: false,

                isLoadingTiles: false,
                isLoadingSensorData: false,
                isLoadingEvents: false,

                paneSize: 72,
                KEY_LOCAL_STORAGE_REAL_TIME_PANE_SIZE: 'REAL_TIME_PANE_SIZE',

                realtimeChartsData: [],
                lastRealTimeData: [],

                eventsReportClustered: [],
                eventsReport: [],
                center: {lat: -25.407688, lng: -49.253990},
                vehicles: [], // lista com todas as maquinas
                vehiclesWithData: [], // lista de maquinas que tem dados
                vehiclesIdsInVisibleCluster: [],

                showHistoricalData: false,
                showRightPaneCharts: false,

                thereIsWorkTrackData: true,
                thereIsIdleTrackData: true,
                thereIsManeuverTrackData: true,
                thereIsTravelTrackData: true,

                selectedOrganizations: [],
                cards: [],
                cardsData: {},
                vehiclesStatusesSelected: [],
                vehiclesStatusesList: VEHICLES_STATUSES_LIST(),

                //https://developers.google.com/maps/documentation/javascript/maptypes
                mapsTypes: [{name: this.$t('AppVehiclesTrack.Mapa'), value: 'roadmap'}, {name: this.$t('AppVehiclesTrack.Satélite'), value: 'hybrid'}],
                mapsTypesSelected: null,

                selectedVehicles: [],
                realtimeDataMarkers: [],
                TIMEOUT_REFRESH_DATA: 5000, // Tempo para pedir os dados da maquina,
                refreshIntervalIdTrackLme: null,
                tilesData: [],
                pbfTilesData: null,
                showBtnBackToRealtime: false,

                optionsSelectWorkType: OPTIONS_SELECT_WORK_TYPE(),
                optionsSelectWorkTypeSelected: null,
                historicalChartsData: [],
                historicalPieChartsData: {
                    atividade_series: [],
                    gasto_combustivel_series: [],
                },

                MAX_REQUEST_VEHICLES_WITHOUT_DEVICES: 5,
                requestCount: 0,
                FIELDS_PAGE_SIZE: 750,
                weather_overlay: null,
                marker_historical: null,
                mapBoundsAndZoom: {
                    zoom: MAPS_DEFAULT_CONFIGS.ZOOM
                },
                fieldsOverlayActive: 'TILES',
                fieldsOverlayActiveOptions: {
                    TILES: 'TILES',
                    DECK: 'DECK'
                },
                showNewVehiclesSelectionDialog: false,
                vehicleIdToStartSelection: "",
                loadingReport: false,
                reportDates: {},
                organizationChangedAfterRequest: false,
                vehiclesChangedAfterRequest: false,
                trackOn: false,
                connectivityOn: false,
                pageableRequestStartLme: 0,
                currentRequestIdLme: null,
                locationBlocked: false,
                displayIdVehicles: [],
                markerInitData: null,
                markerEndData: null,
                gaps: [],
                noTrackOn: false,
                hourMeterSeries: [],
                connectivityEvents: [],
                lastRequest: null,
                orgZone: 'America/Sao_Paulo',
                map_overlay_data: null,
                mapOverlayService: null,
                fleet_status: null,
                idle_machines: [],
                fuel_level: [],
                maintenance_machines: [],
                vehiclesUpdateInterval: null,
                fieldsOverlayData: [],
                allLmeResponse: null,
                vehiclesSliced: null,
                showMapOverlay: process.env.VUE_APP_SHOW_MAP_OVERLAY === 'true',
                organizationsService: null,
                showManualDownloadButton: false,
                loadingManualDownload: false,
                MANUAL_DOWNLOAD_DEALER_ID: '23554909dd944f1bb4c35b44b7e5785f',
                manualPdfUrl: '/docs/manual-usuario-linkcloud.pdf',
            }
        },
        methods: {
            openMaximizable() {
                this.displayMaximizable = true;
            },
            checkShowManualDownloadButton() {
                this.organizationsService.getAllV3('TRACK').then((organizations) => {
                    this.showManualDownloadButton = organizations.some(organization => organization.dealer_id === this.MANUAL_DOWNLOAD_DEALER_ID);
                }).catch((error) => {
                    console.log(error);
                });
            },
            handleDownloadManual() {
                if (this.loadingManualDownload) {
                    return;
                }

                this.loadingManualDownload = true;

                fetch(this.manualPdfUrl)
                    .then(response => response.blob())
                    .then(blob => {
                        let url = window.URL.createObjectURL(blob);
                        let link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Manual do Usuário - LinkCloud.pdf');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    this.loadingManualDownload = false;
                });
            },
            handleShowDetails(){
                // Verifica se existem filtros selecionados
                if (this.vehicles.length === 0 && !this.showPanelStatus) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesTrack.Selecione o cliente'),
                        detail: this.$t('AppVehiclesTrack.Selecione um cliente para continuar'),
                        life: 5000
                    });
                    return;
                }

                // Visualização Full Screen
                let doc = window.document;
                let docEl = doc.documentElement;

                let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
                let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
                let isScreenFull = doc.fullscreenElement || doc.mozFullScreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement;

                // Se o painel estiver ligado, ele é desligado
                if(this.showPanelStatus){
                    this.getAllVehiclesMarkers();
                    this.showPanelStatus = !this.showPanelStatus;
                    this.selectedVehicles = [];
                    this.showPanel = false;
                    if (isScreenFull) {
                        cancelFullScreen.call(doc);
                    }
                    return;
                }

                requestFullScreen.call(docEl);

                // Balão com nome da frota em cima dos markers
                this.showPanel = true;
                this.selectedVehicles = this.selectedVehicles.length > 0 ? this.selectedVehicles : this.vehicles.slice();

                // Se algo foi filtrado executa o método para limpar o resultado
                if(this.showHistoricalData){
                    this.handleBackToRealTime();
                }
                this.showRightPaneCharts = false;

                this.showPanelStatus = !this.showPanelStatus;
            },
            keyF11(event) {
                if (event.key === 'F11') {
                    event.preventDefault();
                }
            },
            reportHasBeenDownloaded() {
                this.loadingReport = false;
            },
            async generateCanvas(canvas) {
                let div = document.getElementById('google-maps-report');
                div.innerHTML = "";
                let image = new Image();
                image.id = "pic";
                image.src = canvas.toDataURL();
                image.style.width = '100%';
                image.style.height = 'auto';
                div.appendChild(image);
                this.$refs.report.generateReport();
            },
            requestPDFReport() {
                this.loadingReport = true;

                this.$toast.add({
                    severity: 'success',
                    summary: this.$t('AppVehiclesTrack.Relatório solicitado com sucesso'),
                    detail: this.$t('AppVehiclesTrack.Aguarde enquanto o relatório carrega'),
                    life: 5000
                });

                htmlToImage
                    .toCanvas(document.querySelector('.google-maps'),
                        { skipFonts: true, preferredFontFormat: 'woff2', backgroundColor: 'white', includeQueryParams: true })
                    .then(canvas => {
                        this.generateCanvas(canvas)
                    })
            },
            statusChanged(val) {
                this.requestCount = 0;
                this.vehiclesStatusesSelected = val;
                this.getAllVehiclesMarkers();
            },
            customMouseOver(values) {
                if (this.showHistoricalData) {
                    for (let i = 0; i < this.historicalChartsData.length; i++) {
                        let index = this.binarySearch(this.historicalChartsData[i].data, values.x);

                        if (index >= 0 && this.isLatLngValid(this.historicalChartsData[i].data[index])) {
                            this.marker_historical = {
                                lat: this.historicalChartsData[i].data[index].lat,
                                lng: this.historicalChartsData[i].data[index].lng
                            };
                            break;
                        }
                    }
                }
            },
            mouseOverEvent(values) {
                if (!this.showHistoricalData) {
                    this.markerInitData = null;
                    this.markerEndData = null;
                    return;
                }

                if (!values) {
                    this.markerInitData = null;
                    this.markerEndData = null;
                    return;
                }

                for (let i = 0; i < this.historicalChartsData.length; i++) {
                    if (values.vid !== this.historicalChartsData.id) {
                        return;
                    }

                    let tsArray = this.historicalChartsData[i].data.map(obj => obj.ts);
                    this.markerInitData = this.createMarkerTimeline(this.historicalChartsData[i].data[this.findClosestValueIndex(tsArray, (values.event_start * 1000))])
                    this.markerEndData = this.createMarkerTimeline(this.historicalChartsData[i].data[this.findClosestValueIndex(tsArray, (values.event_end * 1000))])

                }
            },
            createMarkerTimeline(markerData) {
                if (!markerData) {
                    return null;
                }
                return {
                    lat: markerData.lat,
                    lng: markerData.lng
                };
            },
            findClosestValueIndex(array, goal) {
                return array.reduce((closestIndex, currentValue, currentIndex, arr) => {
                    return Math.abs(currentValue - goal) < Math.abs(arr[closestIndex] - goal) ? currentIndex : closestIndex;
                }, 0);
            },
            isLatLngValid(data) {
                if (!data || !data.lat || !data.lng) {
                    return false;
                }
                return true;
            },

            binarySearch(array, targetValue) {
                var min = 0;
                var max = array.length - 1;
                var guess;

                while (min <= max) {
                    guess = Math.floor((max + min) / 2);

                    if (array[guess].ts === targetValue) {
                        return guess;
                    } else if (array[guess].ts < targetValue) {
                        min = guess + 1;
                    } else {
                        max = guess - 1;
                    }
                }
                return -1;
            },
            binarySearchClosest(array, targetValue) {
                var min = 0;
                var max = array.length - 1;
                var guess;

                while (min <= max) {
                    guess = Math.floor((max + min) / 2);

                    if (array[guess].ts === targetValue) {
                        return guess;
                    } else if (array[guess].ts < targetValue) {
                        min = guess + 1;
                    } else {
                        max = guess - 1;
                    }
                }
                return -1;
            },
            handleBackToRealTime() {

                this.marker_historical = null;

                try {
                    this.$refs.chartsRightSide.restoreStateChartsRealTime();
                } catch (e) {
                    //
                }
                this.requestCount = 0;
                this.clearHistoricalData();
                this.getAllVehiclesMarkers();
                this.realtimeChartsData = [];
            },

            splitPanesResized(event) {
                //se for = 100 está mostrando so um
                if (event[0].size !== 100) {
                    this.storePaneSize(event[0].size);
                    this.paneSize = event[0].size;
                }
            },
            storePaneSize(size) {
                localStorage.setItem(this.KEY_LOCAL_STORAGE_REAL_TIME_PANE_SIZE, JSON.stringify(size));
            },
            retrievePaneSize() {
                let size = JSON.parse(localStorage.getItem(this.KEY_LOCAL_STORAGE_REAL_TIME_PANE_SIZE));
                if (size) {
                    this.paneSize = size;
                }
            },
            async handleCloseNewSelectionDialog(clearSelection) {
                this.showNewVehiclesSelectionDialog = false;
                if (clearSelection) {
                    await this.$refs.filterBar.clearFilters();
                    this.handleClickMarker(this.vehicleIdToStartSelection);
                }
            },
            handleClickMarker(id) {
                if (!this.selectedVehicles.find(v => v.id === id)) {
                    let temp = this.vehicles.find(v => v.id === id);

                    if (!temp) {
                        return;
                    }

                    if(!this.showPanel){
                        //Click no marker deve selecionar so um por vez
                        this.selectedVehicles = [];
                        this.selectedVehicles.push(temp);
                    } else{
                        this.selectedVehicles.push(temp);
                    }
                }
            },
            handleClickCloseInfoWindow(vehicleId) {
                //fechou a infowindow tem que desmarcar a maquina
                let index = this.selectedVehicles.findIndex(v => v.id === vehicleId);

                if (index >= 0) {
                    this.selectedVehicles.splice(index, 1);
                }
            },
            selectedOrganizationsChanged(val) {
                this.selectedOrganizations = val;
                //TODO tem que desativar os tiles ou o deck
                this.removeFieldsFromRealTime();
                this.resetFieldsButton();
                this.organizationChangedAfterRequest = true;
            },
            selectedVehiclesChanged(val) {
                this.selectedVehicles = val;
            },
            vehiclesChanged(val) {
                this.vehicles = val;
                this.getAllVehiclesMarkers();
            },
            updateVehiclesIdsInVisibleCluster(val) {
                this.vehiclesIdsInVisibleCluster = val;
            },
            getAllVehiclesMarkers() {
                this.pageableRequestStartLme = 0;
                this.realtimeDataMarkers = [];
                this.currentRequestIdLme = this.guidGenerator();
                this.$refs.googleMapsRealTime.removeAllMarkers();
                this.cancelRequestsRealTime()
                this.requestPageableRealTimeDataLme(this.currentRequestIdLme);
            },
            guidGenerator() {
                let S4 = function () {
                    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
                };
                return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
            },
            requestPageableRealTimeDataLme(requestId) {
                let request = [];
                const PAGEABLE_REQUEST_MAX = 100;

                if (this.currentRequestIdLme !== requestId) {
                    return
                }

              let vehiclesToRequest = this.vehicles;
              let vehiclesSliced = this.getVehiclesSliced(vehiclesToRequest, PAGEABLE_REQUEST_MAX);

                vehiclesSliced
                    .forEach(vehicle => {
                        if (this.containsInListById(vehicle.id, this.selectedVehicles) >= 0) {
                            return;
                        }

                        let info = {
                            vin: vehicle.identification_number,
                            mac_address: vehicle.mac_address,
                            vid: vehicle.id,
                            org_id: vehicle.organization_id,
                            lme_version: this.showMapOverlay ? 8 : 1,
                            expiration_time: 10000,
                            frequency: 2000
                        };
                        request.push(info);
                    })


                this.realtimeService.requestDataLme(request)
                    .then((response) => {
                        let newResponse = this.removeOldLmes(response)
                        if (this.currentRequestIdLme !== requestId) {
                            return;
                        }

                        if (newResponse) {
                            this.updateRealtimeMarkers(newResponse, vehiclesSliced);
                        }

                        if (this.showMapOverlay) {
                            this.startVehiclesUpdater()
                            this.getFieldsToMapOverlay(newResponse, vehiclesSliced)
                        }
                    }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    if (this.currentRequestIdLme !== requestId) {
                        return;
                    }

                    if (this.pageableRequestStartLme + PAGEABLE_REQUEST_MAX < vehiclesToRequest.length) {
                        this.pageableRequestStartLme = this.pageableRequestStartLme + PAGEABLE_REQUEST_MAX;
                        this.requestPageableRealTimeDataLme(requestId)
                        return;
                    }

                    this.pageableRequestStartLme = 0;
                    this.scheduleGetVehiclesTrackLme();
                });
            },
            getVehiclesSliced(vehiclesToRequest, PAGEABLE_REQUEST_MAX){
                if (this.showMapOverlay) {
                    return vehiclesToRequest;
                }

                return vehiclesToRequest.slice(this.pageableRequestStartLme,
                        Math.min(this.pageableRequestStartLme + PAGEABLE_REQUEST_MAX, vehiclesToRequest.length));
            },
            updateRealtimeMarkers(response, vehiclesSliced) {
                let tempRealtimeDataMarkers = [];
                let idsMap = this.realtimeDataMarkers.map(obj => obj.id);

                vehiclesSliced.forEach(vehicle => {
                    if (!response.map((obj => obj.id)).includes(vehicle.id)) {
                        if (!idsMap.includes(vehicle.id)) {
                            tempRealtimeDataMarkers.push({
                                'id': vehicle.id,
                                'identification': vehicle.identification,
                                '_035': vehicle.identification_number,
                                "_009": vehicle.latitude,
                                "_010": vehicle.longitude,
                                "_005": vehicle.last_contact,
                                "is_unavailable": vehicle.unavailability_date
                            })
                            return;
                        }
                    }
                })

                response.forEach(eachResponse => {
                    let vehicle = vehiclesSliced.filter((obj) => obj.id === eachResponse.id)

                    if (vehicle.length > 0) {
                        eachResponse["identification"] = vehicle[0].identification;
                        eachResponse["is_unavailable"] = vehicle[0].unavailability_date;
                    }

                    if (!idsMap.includes(eachResponse.id)) {
                        tempRealtimeDataMarkers.push(eachResponse)
                        return;
                    }

                    let index = this.realtimeDataMarkers.findIndex((obj) => obj.id === response.id);

                    if (index < 0) {
                        return;
                    }

                    this.realtimeDataMarkers[index] = eachResponse;
                });

                if (tempRealtimeDataMarkers.length > 0) {
                    this.realtimeDataMarkers.push(...tempRealtimeDataMarkers);
                }
            },
            getRealTimeDataLme() {

                //se saiu da tela mas vai fazer algum request, realiza o cancelamento
                if (!this.$route.name.includes('vehicles-track')) {
                    this.cancelRequestsRealTime();
                    return;
                }

                if (this.showHistoricalData) {
                    return;
                }

                let vm = this;

                if (!this.vehicles || this.vehicles.length === 0) {
                    return;
                }

                let request = [];
                this.vehicles.forEach(vehicle => {
                    if (!this.needsToRequestRealTimeData(vehicle)) {
                        return;
                    }

                    if (this.containsInListById(vehicle.id, this.selectedVehicles) < 0 &&
                        !this.vehiclesIdsInVisibleCluster.includes(vehicle.id)) {
                        return;
                    }

                    let info = {
                        vin: vehicle.identification_number,
                        mac_address: vehicle.mac_address,
                        vid: vehicle.id,
                        org_id: vehicle.organization_id,
                        lme_version: this.showMapOverlay ? 8 : 1,
                        expiration_time: 10000,
                        frequency: 2000
                    };

                    //se for uma maquina selecionada tem que pedir mais dados
                    if (this.containsInListById(vehicle.id, this.selectedVehicles) >= 0) {
                        request.push({ ...info });

                        let info2 = { ...info };
                        info2.lme_version = vehicle.lme_version || 2;

                        request.push(info2);

                        return
                    }

                    request.push(info);
                })

                this.organizationChangedAfterRequest = false;
                this.vehiclesChangedAfterRequest = false;
                this.realtimeService.requestDataLme(request)
                    .then((response) => {
                        let newResponse = this.removeOldLmes(response)
                        let responseMerged = this.mergeLmesByVehicleId(newResponse);
                        if(this.showMapOverlay){
                            this.updatedAllLmeResponse(responseMerged)
                        }
                        vm.prepareRealTimeData(responseMerged);
                    }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    if (this.requestCount <= this.MAX_REQUEST_VEHICLES_WITHOUT_DEVICES) {
                        this.requestCount++;
                    }
                });
            },
            mergeLmesByVehicleId(response) {
                let map = new Map();

                response.forEach(element => {
                    if (!map.has(element.id)) {
                        map.set(element.id, element);
                        return;
                    }

                    let values = map.get(element.id);
                    let isLmeV8 = element._1010038 || element._1010040;

                    if (isLmeV8) {
                        // LME v8 → sobrescreve chaves iguais
                        map.set(element.id, {
                            ...values,
                            ...element
                        });
                        return;
                    }

                    // LME v2 → ignora chaves que já existem
                    let merged = { ...values };

                    Object.keys(element).forEach(key => {
                        if (!(key in values)) {
                            merged[key] = element[key];
                        }
                    });

                    map.set(element.id, merged);
                });

                return Array.from(map.values());
            },
            needsToRequestRealTimeData(vehicleData) {
                return vehicleData.device_id;
            },
            prepareRealTimeData(data) {
                //Também verifica após resposta do servidor
                if (this.showHistoricalData) {
                    return;
                }

                if (this.organizationChangedAfterRequest || this.vehiclesChangedAfterRequest) {
                    this.getRealTimeData();
                    return;
                }

                data.forEach((eachData) => {
                    let vehicle = this.vehicles.find((vehicle) => {return vehicle.id === eachData.id})
                    if (!vehicle) {
                        return
                    }
                    eachData.is_unavailable = vehicle.unavailability_date
                })

                if (data && data.length > 0) {
                    this.realtimeDataMarkers = data;
                    this.realtimeChartsData = data;
                }
            },
            containsInListById(id, list) {
                if (!list || list.length === 0) {
                    return -1;
                }
                return list.findIndex(item => item.id === id);
            },
            scheduleGetVehiclesTrackLme() {
                let vm = this;

                if(this.showMapOverlay){
                    vm.getRealTimeDataLme();
                }

                //so deixa agendar se n foi agendado anteriormente
                if (!this.refreshIntervalIdTrackLme) {
                    this.refreshIntervalIdTrackLme = setInterval(function () {
                        vm.getRealTimeDataLme();
                    }, vm.TIMEOUT_REFRESH_DATA)
                }
            },
            cancelRequestsRealTime() {
                clearInterval(this.refreshIntervalIdTrackLme);
                this.refreshIntervalIdTrackLme = null;

                this.realtimeChartsData = [];
            },
            validateDataPreRequest(dates, selectedOrganizations, selectedVehicles, organizations) {

                if (selectedVehicles.length === 0) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesTrack.Selecione a organização'),
                        detail: this.$t('AppVehiclesTrack.Selecione uma organização para continuar'),
                        life: 5000
                    });
                    return;
                }

                if (this.showPanel) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesTrack.Desligue o monitoramento'),
                        detail: this.$t('AppVehiclesTrack.Desligue o modo de monitoramento para continuar'),
                        life: 5000
                    });
                    return;
                }

                this.displayMaximizable = false;
                this.reportDates = dates;
                this.cards = [];

                // Fuso da organização (primeira selecionada), normalizado para um nome de
                // zona reconhecido pelo moment-timezone. Usado para montar a janela da
                // consulta no fuso da org, e não no do navegador.
                const orgZone = this.resolveOrgZone(
                    selectedOrganizations && selectedOrganizations[0] && selectedOrganizations[0].zoneOffset
                );
                this.orgZone = orgZone;

                this.getTilesList(dates, selectedVehicles, orgZone);
            },
            handleMapControlClick(val) {
                switch (val) {
                    case 'roadmap':
                        this.mapsTypesSelected = 'roadmap';
                        break;
                    case 'hybrid':
                        this.mapsTypesSelected = 'hybrid';
                        break;
                    case 'fields':
                        this.showHideFields();
                        break;
                    case 'noTrack':
                        this.noTrackOn = !this.noTrackOn;
                        break;
                    case 'location':
                        this.locationOn = !this.locationOn;
                        this.getCurrentLocation();
                        break;
                    case 'connectivity':
                        this.connectivityOn = !this.connectivityOn;
                        this.connectivityEvents = [];
                        if (this.connectivityOn) {
                            this.getConnectivityEvents();
                            break;
                        }
                        this.$refs.googleMapsRealTime.removeConnectivityTracks();
                        break;
                    case MAPS_OVERLAY_WEATHER_TYPES.PRECIPITATION:
                        this.setupWeatherOverlay(MAPS_OVERLAY_WEATHER_TYPES.PRECIPITATION);
                        break;
                    case MAPS_OVERLAY_WEATHER_TYPES.TEMPERATURE:
                        this.setupWeatherOverlay(MAPS_OVERLAY_WEATHER_TYPES.TEMPERATURE);
                        break;
                    case MAPS_OVERLAY_WEATHER_TYPES.CLOUDS:
                        this.setupWeatherOverlay(MAPS_OVERLAY_WEATHER_TYPES.CLOUDS);
                        break;
                    case MAPS_OVERLAY_WEATHER_TYPES.REMOVE:
                        this.setupWeatherOverlay(MAPS_OVERLAY_WEATHER_TYPES.REMOVE);
                        break;
                    case MAPS_OVERLAY_WORK_TYPES.TRACK:
                        this.trackOn = !this.trackOn;
                        break;
                    default:
                    // console.log("Valor inesperado: ", val)
                }
            },

            setupWeatherOverlay(overlay) {
                switch (overlay) {
                    case MAPS_OVERLAY_WEATHER_TYPES.PRECIPITATION:
                        this.weather_overlay = MAPS_OVERLAY_OPEN_WEATHER_TYPES.PRECIPITATION;
                        break;
                    case MAPS_OVERLAY_WEATHER_TYPES.TEMPERATURE:
                        this.weather_overlay = MAPS_OVERLAY_OPEN_WEATHER_TYPES.TEMPERATURE;
                        break;
                    case MAPS_OVERLAY_WEATHER_TYPES.CLOUDS:
                        this.weather_overlay = MAPS_OVERLAY_OPEN_WEATHER_TYPES.CLOUDS;
                        break;
                    case MAPS_OVERLAY_WEATHER_TYPES.REMOVE:
                        this.weather_overlay = MAPS_OVERLAY_WEATHER_TYPES.REMOVE;
                        break;
                    default:
                        console.log("Valor inesperado: ", overlay)
                }

                if (this.$refs.googleMapsRealTime) {
                    this.$refs.googleMapsRealTime.setupWeatherOverlay();
                }
            },

            isThereJustOneOrganizationToOpenFieldsManager() {
                if (this.selectedOrganizations.length === 0) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesTrack.Escolha uma organização'),
                        detail: this.$t('AppVehiclesTrack.Escolha uma organização para acessar locais'),
                        life: 3000
                    });
                    return false;
                }

                if (this.selectedOrganizations.length > 1) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesTrack.Escolha uma organização'),
                        detail: this.$t('AppVehiclesTrack.Escolha apenas uma organização para acessar locais'),
                        life: 3000
                    });
                    return false;
                }

                return true;
            },
            showHideFields() {


                if (this.showFields) {
                    this.removeFieldsFromRealTime();
                    return;
                }


                if (!this.isThereJustOneOrganizationToOpenFieldsManager()) {
                    this.resetFieldsButton();
                    return;
                }

                this.customerHasFields(this.selectedOrganizations[0].id)

            },

            getFields() {
                this.fieldsService.isAuthorized(this.selectedOrganizations[0].id).then(() => {
                    if (this.useFieldsTiles) {
                        this.getFieldsTiles();
                    } else {
                        this.getFieldsDeck();
                    }

                    this.showFields = true;
                }).catch((error) => {
                    this.resetFieldsButton();
                    if (!error.response || error.response.status !== 403) {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppVehiclesTrack.Não foi possivel completar a operação'),
                            life: 5000
                        });
                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesTrack.Você não tem acesso a esta funcionalidade'),
                        life: 5000
                    });
                })
            },
            getFieldsTiles() {
                this.$refs.googleMapsRealTime.setupTilesFieldsOverlay(this.selectedOrganizations[0].id);
            },
            customerHasFields(orgId) {
                this.fieldsService.getNumberOfFieldsV3(orgId)
                    .then((response) => {
                        if (response.number_of_fields > 0) {
                            this.getFields();
                        } else {
                            this.$toast.add({
                                severity: 'info',
                                summary: this.$t('AppVehiclesTrack.Não foram localizados locais'),
                                detail: this.$t('AppVehiclesTrack.Nenhum local localizado para a organização'),
                                life: 5000
                            });
                        }
                    }).catch((error) => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesTrack.Não foi possível realizar a operação'),
                        detail: this.$t('AppVehiclesTrack.Não foi possivel mostrar os locais da organização'),
                        life: 5000
                    });
                })
            },
            getFieldsDeck() {

                let params = {
                    swLat: this.mapBoundsAndZoom.sw_lat,
                    swLng: this.mapBoundsAndZoom.sw_lng,
                    neLat: this.mapBoundsAndZoom.ne_lat,
                    neLng: this.mapBoundsAndZoom.ne_lng,
                };

                this.fieldsService.getFieldsV3(this.selectedOrganizationId, params)
                    .then((response) => {
                        this.fieldsToMap(response);
                    }).catch((error) => {
                    console.log(error)
                })
            },
            resetFieldsButton() {
                this.$refs.googleMapsTypeControl.resetFieldsButton();
            },
            fieldsToMap(response) {
                this.$refs.googleMapsRealTime.fieldsToMap(response.fields);
            },
            removeFieldsFromRealTime() {
                this.showFields = false;
                this.$refs.googleMapsRealTime.removeFieldsFromRealTime();
                this.$refs.googleMapsRealTime.removeFieldsTiles();
            },
            getCurrentLocation() {
                let options = {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                };

                let firstCall = true; // Verifica se é a primeira chamada
                let errorMessage;

                if (!this.locationOn) {
                    clearInterval(this.getLocationInterval);
                    this.markerLocation = null;
                    return;
                }

                const getLocation = () => {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition((pos) => {
                            let latLng = { lat: pos.coords.latitude, lng: pos.coords.longitude };
                            if(firstCall){
                                this.center = latLng; // Executa somente na primeira chamada se o cliente solicitou a localização atual
                                firstCall = false;
                            }
                            this.markerLocation = latLng;
                        }, (error) => {
                            // Traduz a mensagem caso o erro seja: User denied Geolocation
                            if(error.message == "User denied Geolocation"){
                                errorMessage = this.$t('AppVehiclesTrack.Localização negada pelo usuário')
                            } else{
                                errorMessage = error.message
                            }
                            this.$toast.add({
                                severity: 'error', summary:  this.$t('AppVehiclesTrack.Falha'),
                                detail: errorMessage, life: 3000
                            });
                            clearInterval(this.getLocationInterval);
                            this.markerLocation = null;
                            this.locationOn = false;
                        }, options);
                    } else {
                        this.$toast.add({
                            severity: 'error', summary:  this.$t('AppVehiclesTrack.Falha'),
                            detail: this.$t('AppVehiclesTrack.Geolocalização não suportada por este navegador'), life: 3000
                        });
                        clearInterval(this.getLocationInterval);
                        this.markerLocation = null;
                        this.locationOn = false;
                    }
                };

                // Chama a função pela primeira vez
                getLocation();

                // Verifica permissões do usuário e caso a localização for permitida, inicia a atualização a cada 2 segundos
                navigator.permissions.query({ name: 'geolocation' }).then((result) => {
                    if (result.state === 'granted') {
                        getLocation();
                        this.getLocationInterval = setInterval(getLocation, 2000);
                    } else if(result.state === 'denied'){
                        this.locationPermission = true;
                    }
                    result.onchange = () => {
                        if (result.state === 'granted' && !this.locationPermission) {
                            getLocation();
                            this.getLocationInterval = setInterval(getLocation, 2000);
                        } else if(result.state === 'denied'){
                            this.locationPermission = true;
                        }
                    }
                });
            },

            /**
             * Retorna true no primeiro zoom que tem tiles de qqr maquina
             *
             * **/
            hasMbTiles(payload) {
                return payload.zooms && payload.zooms.length > 0;
            },
            hasTiles(payload) {
                for (let i = 0; i < payload.length; i++) {
                    for (let j = 0; j < payload[i].zooms.length; j++) {
                        let temp = payload[i].zooms[j].tiles.length;

                        if (temp > 0) {
                            return true
                        }
                    }
                }
                return false
            },
            // Converte o zoneOffset da organização em um nome de zona que o moment-timezone
            // entenda. O backend pode salvar tanto nomes IANA (America/Sao_Paulo) quanto
            // offsets (-03:00, GMT-3, -3). Offsets são convertidos para Etc/GMT (sinal
            // invertido); valores não reconhecidos caem em America/Sao_Paulo.
            resolveOrgZone(zoneOffset) {
                if (!zoneOffset) {
                    return 'America/Sao_Paulo';
                }
                if (moment.tz.zone(zoneOffset)) {
                    return zoneOffset;
                }
                const match = String(zoneOffset).match(/([+-]?\d{1,2})(?::?(\d{2}))?$/);
                if (match) {
                    const sign = match[1].startsWith('-') ? -1 : 1;
                    const hours = Math.abs(parseInt(match[1], 10));
                    const minutes = match[2] ? parseInt(match[2], 10) : 0;
                    // Etc/GMT só representa offsets de horas cheias, com sinal invertido
                    if (minutes === 0 && hours <= 14) {
                        return 'Etc/GMT' + (sign < 0 ? '+' : '-') + hours;
                    }
                }
                console.warn('[AppVehiclesTrack] zoneOffset não reconhecido, usando America/Sao_Paulo:', zoneOffset);
                return 'America/Sao_Paulo';
            },
            // Reinterpreta o relógio escolhido no date picker (componentes em horário do
            // navegador) como sendo do fuso da organização, devolvendo o epoch em ms (UTC).
            toOrgEpochMs(dateObj, zone) {
                const wall = moment(dateObj).format('YYYY-MM-DD HH:mm:ss');
                return moment.tz(wall, 'YYYY-MM-DD HH:mm:ss', zone).valueOf();
            },
            getTilesList(dates, selectedVehicles, orgZone) {
                if (dates.start_date > new Date("2025-07-24")) {
                    this.getPbfTiles(dates, selectedVehicles, orgZone);
                    return;
                }

                this.getPngTiles(dates, selectedVehicles, orgZone);
            },
            getPbfTiles(dates, selectedVehicles, orgZone) {

                this.isLoadingTiles = true;

                let payload = {
                    start_date: this.toOrgEpochMs(dates.start_date, orgZone),
                    end_date: this.toOrgEpochMs(dates.end_date, orgZone),
                    vids: selectedVehicles.map(v => v.id),
                    ids: selectedVehicles.map(v => v.id)
                };
                this.lastRequest = payload;

                this.trackService.findPbfTilesByVIDAndDateV3(payload)
                    .then((response) => {

                        if (this.hasMbTiles(response)) {

                            this.$refs.chartsRightSide.saveStateChartsRealTime();

                            this.showHistoricalData = true;
                            this.stopVehiclesUpdater();
                            this.cancelRequestsRealTime();
                            this.$refs.googleMapsRealTime.removeAllMarkers();

                            this.pbfTilesData = response;
                            this.getHistoricalData(payload);
                            this.getEvents(payload);
                            this.trackOn = true;

                        } else {
                            this.$toast.add({
                                severity: 'info',
                                summary: this.$t('AppVehiclesTrack.Sem dados no período'),
                                detail: this.$t('AppVehiclesTrack.Não foram localizados dados para o período informado'),
                                life: 5000
                            });

                            this.isLoadingTiles = false;
                            this.isLoadingSensorData = false;
                            this.isLoadingTiles = false;
                        }
                    }).catch((error) => {
                    console.log(error)
                }).finally(() => {
                    this.isLoadingTiles = false;
                })
            },
            getPngTiles(dates, selectedVehicles, orgZone) {

                this.isLoadingTiles = true;

                let payload = {
                    start_date: this.toOrgEpochMs(dates.start_date, orgZone),
                    end_date: this.toOrgEpochMs(dates.end_date, orgZone),
                    ids: selectedVehicles.map(v => v.id)
                };
                this.lastRequest = payload;

                this.trackService.findByTilesByVIDAndDateV3(payload)
                    .then((response) => {

                        if (this.hasTiles(response)) {

                            this.$refs.chartsRightSide.saveStateChartsRealTime();

                            this.showHistoricalData = true;
                            this.stopVehiclesUpdater();
                            this.cancelRequestsRealTime();
                            this.$refs.googleMapsRealTime.removeAllMarkers();

                            this.tilesData = response;
                            this.getHistoricalData(payload);
                            this.getEvents(payload);
                            this.trackOn = true;

                        } else {
                            this.$toast.add({
                                severity: 'info',
                                summary: this.$t('AppVehiclesTrack.Sem dados no período'),
                                detail: this.$t('AppVehiclesTrack.Não foram localizados dados para o período informado'),
                                life: 5000
                            });

                            this.isLoadingTiles = false;
                            this.isLoadingSensorData = false;
                            this.isLoadingTiles = false;
                        }
                    }).catch((error) => {
                    console.log(error)
                }).finally(() => {
                    this.isLoadingTiles = false;
                })
            },
            clearHistoricalData() {
                this.tilesData = [];
                this.pbfTilesData = null;
                this.gaps = [];
                this.showHistoricalData = false;
                this.connectivityOn = false;
                this.$refs.googleMapsTypeControl.resetConnectivityButton();
                this.$refs.googleMapsRealTime.removeConnectivityTracks();
            },

            getEvents(values) {

                this.isLoadingEvents = true;
                this.eventsReport = [];
                const promises = [];
                let vm = this

                values.ids.forEach(function (vid) {
                    promises.push(vm.reportsService.getReportV2(vid, values.start_date, values.end_date));
                })

                Promise.all(promises)
                    .then((response) => {
                        // Ajusta modo para eventos de manutenção
                        response = response.map(resultData =>
                            resultData.map(event => ({
                                ...event,
                                mode: event.is_maintenance ? 8 : event.mode
                            }))
                        )

                        this.setDataToHourMeter(response, values)

                        let allEvents = [];
                        let eventsResponse = [];
                        response.forEach(result => {
                            if (result.status === 'rejected') {
                                return;
                            }
                            allEvents.push(...result)
                            eventsResponse.push(...countableEvents(result))
                        })

                        this.eventsReport = eventsResponse;

                        this.processEventsGaps(allEvents);
                        this.processEventsReport();
                        this.populeCalcValues(eventsResponse);
                    }).catch((error) => {
                    console.log(error)
                    // sem apontamentos não há horímetro: limpa para não deixar o
                    // gráfico com os dados do filtro anterior
                    this.hourMeterSeries = [];
                    if (error.response && error.response.status === 404) {
                        this.$toast.add({
                            severity: 'warn',
                            summary: this.$t('AppVehiclesTrack.Sem dados no periodo'),
                            detail: this.$t('AppVehiclesTrack.Não foi possível localizar apontamentos do veículo no periodo informado'),
                            life: 5000
                        });
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppVehiclesTrack.Operação falhou'),
                            detail: this.$t('AppVehiclesTrack.Não foi possivel realizar a operação'),
                            life: 5000
                        });
                    }
                }).finally(() => {
                    this.isLoadingEvents = false;
                })
            },
            getConnectivityEvents() {
                let params = {
                    vid: this.lastRequest.ids[0],
                    start: this.lastRequest.start_date - 10800000,
                    end: this.lastRequest.end_date + 10800000
                };
                this.reportsService.getConnectivityEvents(params).then(response => {
                    this.connectivityEvents = response
                }).catch((error) => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesTrack.Operação falhou'),
                        detail: this.$t('AppVehiclesTrack.Não foi possivel buscar eventos de conectividade'),
                        life: 5000
                    });
                    this.connectivityOn = false;
                    this.$refs.googleMapsTypeControl.resetConnectivityButton();
                })
            },
            setDataToHourMeter(results, payload) {
                let series = []
                let modeToColor = {
                    0: '#BDBDBD',
                    1: '#2CA02C', // green - working
                    2: '#D62728', // red - idle
                    3: '#FFAA00', // orange - maneuvering
                    4: '#1F76B4', // blue - traveling
                    5: '#5E3F20', // brown - off
                    8: '#B507A7' // purple - maintenance
                }

                results.forEach((result, index) => {
                    // cor fixa (azul do tema) para a linha não depender do índice do palette
                    series[index] = { type: 'line', data: [], markArea: { data: [] }, name: '', itemStyle: { color: '#2b908f' }, lineStyle: { color: '#2b908f' } }
                    if (result.length === 0) return

                    series[index].name = this.selectedVehicles[index].display_id

                    result.sort((a, b) => a.event_start - b.event_start);
                    result.forEach((data, i) => {
                        let { mode, event_start, event_end, hour_meter_start, hour_meter_end } = data;

                        let start = event_start * 1000;
                        let end = event_end * 1000;

                        // Extrai os pontos para criar o gráfico de linha
                        let hourMeter = hour_meter_start < 1 ? null : hour_meter_start
                        series[index].data.push([start, hourMeter]);

                        // Verificações para adicionar o hour_meter_end no gráfico
                        let nextEvent = result[i + 1]
                        // Se for o último evento no array
                        if(nextEvent === undefined){
                            series[index].data.push(hour_meter_end < 1 ? [end, null] : [end, hour_meter_end])
                        }
                        // Se o próximo evento começar em um momento diferente
                        if(nextEvent != undefined && nextEvent.event_start !== event_end){
                            series[index].data.push(hour_meter_end < 1 ? [end, null] : [end, hour_meter_end], [end, null]);
                        }
                        // Se o próximo evento não tem valor inicial de horímetro, mas o evento atual tem
                        if(nextEvent != undefined && nextEvent.hour_meter_start < 1 && hour_meter_end >= 1){
                            series[index].data.push([end, hour_meter_end])
                        }

                        if(series[index].markArea.data.length > 0 && series[index].markArea.data[series[index].markArea.data.length - 1][0].itemStyle.color === modeToColor[mode] &&
                                series[index].markArea.data[series[index].markArea.data.length - 1][1].xAxis === start) {
                            series[index].markArea.data[series[index].markArea.data.length - 1][1].xAxis = end
                        } else {
                            series[index].markArea.data.push([
                                { xAxis: start, itemStyle: { color: modeToColor[mode], opacity: 0.7 } },
                                { xAxis: end }
                            ]);
                        }
                    });

                    series[index].data.unshift([payload.start_date, null])
                    series[index].data.push([payload.end_date, null])
                })

                this.hourMeterSeries = series
            },
            processEventsGaps(events) {
                this.gaps = [];
                let gapsTemp = [];
                events.forEach(event => {
                    if (event.gap) {
                        gapsTemp.push(event.gap);
                    }
                })
                this.gaps = gapsTemp;
            },
            processEventsReport() {
                let eventsClusteredTemp = [];
                this.eventsReport.forEach(event => {
                    if (event.mode !== 2 && event.mode !== 5) {
                        return;
                    }

                    let eventClustered = eventsClusteredTemp.find(obj => {
                        return obj.reason_description === event.reason_description
                    });
                    if (eventClustered) {
                        eventClustered.total_time = eventClustered.total_time + event.time;
                        return;
                    }

                    eventsClusteredTemp.push({
                        total_time: event.time,
                        reason_description: event.reason_description
                    })
                });

                this.eventsReportClustered = eventsClusteredTemp;
            },
            populeCalcValues(values) {
                let events = normalizeEvents(values);

                this.cardsData = {
                    total: summarize(events),
                    byMode: {
                        [MODE.PRODUCING]: summarize(eventsByMode(events, MODE.PRODUCING)),
                        [MODE.IDLE]: summarize(eventsByMode(events, MODE.IDLE)),
                        [MODE.MANEUVERING]: summarize(eventsByMode(events, MODE.MANEUVERING)),
                        [MODE.TRAVELING]: summarize(eventsByMode(events, MODE.TRAVELING))
                    }
                };

                let fuels = fuelByMode(events);
                let fuelTotal = totalFuel(events);
                let fuelPercentage = mode => Math.round((fuels[mode] / fuelTotal) * 100);

                this.historicalPieChartsData.gasto_combustivel_series = [
                    {name: this.$t('AppVehiclesTrack.Ocioso'), value: fuelPercentage(MODE.IDLE), itemStyle: {color: '#d62728'}, rawValue: fuels[MODE.IDLE]},
                    {name: this.$t('AppVehiclesTrack.Manobrando'), value: fuelPercentage(MODE.MANEUVERING), itemStyle: {color: '#ff7e0e'}, rawValue: fuels[MODE.MANEUVERING]},
                    {name: this.$t('AppVehiclesTrack.Produzindo'), value: fuelPercentage(MODE.PRODUCING), itemStyle: {color: '#2ca02c'}, rawValue: fuels[MODE.PRODUCING]},
                    {name: this.$t('AppVehiclesTrack.Deslocando'), value: fuelPercentage(MODE.TRAVELING), itemStyle: {color: '#1f76b4'}, rawValue: fuels[MODE.TRAVELING]},
                    {name: this.$t('AppVehiclesTrack.Manutenção'), value: fuelPercentage(MODE.MAINTENANCE), itemStyle: {color: '#B507A7'}, rawValue: fuels[MODE.MAINTENANCE]}
                ];

                let times = timeByMode(events);
                let period = monitoredPeriod(events);
                let timePercentage = mode => this.formatValue((times[mode] / period) * 100);

                this.historicalPieChartsData.atividade_series = [
                    {name: this.$t('AppVehiclesTrack.Ocioso'), value: timePercentage(MODE.IDLE), itemStyle: {color: '#d62728'}, rawValue: times[MODE.IDLE]},
                    {name: this.$t('AppVehiclesTrack.Manobrando'), value: timePercentage(MODE.MANEUVERING), itemStyle: {color: '#ff7e0e'}, rawValue: times[MODE.MANEUVERING]},
                    {name: this.$t('AppVehiclesTrack.Produzindo'), value: timePercentage(MODE.PRODUCING), itemStyle: {color: '#2ca02c'}, rawValue: times[MODE.PRODUCING]},
                    {name: this.$t('AppVehiclesTrack.Deslocando'), value: timePercentage(MODE.TRAVELING), itemStyle: {color: '#1f76b4'}, rawValue: times[MODE.TRAVELING]},
                    {name: this.$t('AppVehiclesTrack.Desligado'), value: timePercentage(MODE.OFF), itemStyle: {color: '#5E3F20'}, rawValue: times[MODE.OFF]},
                    {name: this.$t('AppVehiclesTrack.Manutenção'), value: timePercentage(MODE.MAINTENANCE), itemStyle: {color: '#B507A7'}, rawValue: times[MODE.MAINTENANCE]}
                ];

                this.handleChangeWorkType();
            },
            formatValue(value) {
                return parseFloat((value).toFixed(2))
            },
            addFieldToChartArray(value, name, color) {
                if (value > 0) {
                    this.chartArrayToPush.push({name: name, value: value, itemStyle: {color: color}});
                }
            },
            handleChangeWorkType() {
                this.cards = [];

                if (!this.cardsData.total) {
                    return;
                }

                let total = this.cardsData.total;
                let byMode = this.cardsData.byMode;

                if (this.optionsSelectWorkTypeSelected.key === 'TOTAL') {
                    this.pushCard({title: this.$t('AppVehiclesTrack.Área'), value: this.checkValue(total.area, 'ha'), tooltip: this.$t('AppVehiclesTrack.Área total registrada no período')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Combustível Total'), value: this.checkValue(total.totalFuel, 'L'), tooltip: this.$t('AppVehiclesTrack.Combustível total gasto')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Período monitorado'), value: this.checkValue(total.monitoredPeriod, 'h'), tooltip: this.$t('AppVehiclesTrack.Tempo total com dados da máquina no período')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Tempo de Motor Ligado'), value: this.checkValue(total.engineOnTime, 'h'), tooltip: this.$t('AppVehiclesTrack.Tempo de motor ligado fora de manutenção')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Distância'), value: this.checkValue(total.distance, 'km'), tooltip: this.$t('AppVehiclesTrack.Distância total percorrida')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Velocidade'), value: this.checkValue(total.speed, 'km/h'), tooltip: this.$t('AppVehiclesTrack.Distância percorrida em modo Produzindo, Manobrando e Deslocando sobre Horas Produtivas')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Taxa de combustível (Área)'), value: this.checkValue(total.fuelRateByArea, 'km/L'), tooltip: this.$t('AppVehiclesTrack.Distância total percorrida sobre consumo total de combustível')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Taxa de combustível (Tempo)'), value: this.checkValue(total.fuelRateByTime, 'L/h'), tooltip: this.$t('AppVehiclesTrack.Combustível com motor ligado sobre tempo de motor ligado')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Produtividade'), value: this.checkValue(total.productivity, 'ha/h'), tooltip: this.$t('AppVehiclesTrack.Área total sobre Horas Produtivas')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Rendimento'), value: this.checkValue(total.fuelPerHectare, 'L/ha'), tooltip: this.$t('AppVehiclesTrack.Consumo total de combustível sobre área total')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Disponibilidade mecânica'), value: this.checkValue(total.mechanicalAvailability, '%'), tooltip: this.$t('AppVehiclesTrack.Porcentagem do tempo pesquisado fora de uma parada de manutenção')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Eficiência'), value: this.checkValue(total.efficiency, '%'), tooltip: this.$t('AppVehiclesTrack.Porcentagem do Período monitorado em modo Produzindo, Manobrando e Deslocando')});
                    return;
                }

                if (this.optionsSelectWorkTypeSelected.key === 'TRABALHANDO') {
                    let summary = byMode[MODE.PRODUCING];
                    if (summary.totalTime === 0) {
                        return;
                    }

                    this.pushCard({title: this.$t('AppVehiclesTrack.Área'), value: this.checkValue(summary.area, 'ha'), tooltip: this.$t('AppVehiclesTrack.Área registrada em modo Produzindo')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Combustível Produzindo'), value: this.checkValue(summary.totalFuel, 'L'), tooltip: this.$t('AppVehiclesTrack.Combustível gasto em modo Produzindo')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Tempo Produzindo'), value: this.checkValue(summary.totalTime, 'h'), tooltip: this.$t('AppVehiclesTrack.Tempo de motor ligado em modo Produzindo')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Velocidade'), value: this.checkValue(summary.speed, 'km/h'), tooltip: this.$t('AppVehiclesTrack.Distância percorrida em modo Produzindo sobre tempo em modo Produzindo')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Taxa de combustível (Tempo)'), value: this.checkValue(summary.fuelRateByTime, 'L/h'), tooltip: this.$t('AppVehiclesTrack.Consumo de combustível em modo Produzindo sobre tempo em modo Produzindo')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Produtividade'), value: this.checkValue(summary.productivity, 'ha/h'), tooltip: this.$t('AppVehiclesTrack.Área em modo Produzindo sobre tempo em modo Produzindo')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Rendimento'), value: this.checkValue(summary.fuelPerHectare, 'L/ha'), tooltip: this.$t('AppVehiclesTrack.Consumo de combustível em modo Produzindo sobre área em modo Produzindo')});
                    return;
                }

                if (this.optionsSelectWorkTypeSelected.key === 'OCIOSO') {
                    let summary = byMode[MODE.IDLE];
                    if (summary.totalTime === 0) {
                        return;
                    }

                    this.pushCard({title: this.$t('AppVehiclesTrack.Combustível Ocioso'), value: this.checkValue(summary.totalFuel, 'L'), tooltip: this.$t('AppVehiclesTrack.Combustível gasto em modo Ocioso')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Tempo Ocioso'), value: this.checkValue(summary.totalTime, 'h'), tooltip: this.$t('AppVehiclesTrack.Tempo de motor ligado em modo Ocioso')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Taxa de combustível (Tempo)'), value: this.checkValue(summary.fuelRateByTime, 'L/h'), tooltip: this.$t('AppVehiclesTrack.Consumo de combustível em modo Ocioso sobre tempo de motor ligado em modo Ocioso')});
                    return;
                }

                if (this.optionsSelectWorkTypeSelected.key === 'MANOBRANDO') {
                    let summary = byMode[MODE.MANEUVERING];
                    if (summary.totalTime === 0) {
                        return;
                    }

                    this.pushCard({title: this.$t('AppVehiclesTrack.Combustível Manobrando'), value: this.checkValue(summary.totalFuel, 'L'), tooltip: this.$t('AppVehiclesTrack.Combustível gasto em modo Manobrando')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Tempo Manobrando'), value: this.checkValue(summary.totalTime, 'h'), tooltip: this.$t('AppVehiclesTrack.Tempo de motor ligado em modo Manobrando')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Taxa de combustível (Tempo)'), value: this.checkValue(summary.fuelRateByTime, 'L/h'), tooltip: this.$t('AppVehiclesTrack.Consumo de combustível em modo Manobrando sobre tempo de motor ligado em modo Manobrando')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Velocidade'), value: this.checkValue(summary.speed, 'km/h'), tooltip: this.$t('AppVehiclesTrack.Distância percorrida em modo Manobrando sobre tempo de motor ligado em modo Manobrando')});
                    return;
                }

                if (this.optionsSelectWorkTypeSelected.key === 'DESLOCANDO') {
                    let summary = byMode[MODE.TRAVELING];
                    if (summary.totalTime === 0) {
                        return;
                    }

                    this.pushCard({title: this.$t('AppVehiclesTrack.Combustível Deslocando'), value: this.checkValue(summary.totalFuel, 'L'), tooltip: this.$t('AppVehiclesTrack.Combustível gasto em modo Deslocando')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Tempo Deslocando'), value: this.checkValue(summary.totalTime, 'h'), tooltip: this.$t('AppVehiclesTrack.Tempo de motor ligado em modo Deslocando')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Taxa de combustível (Tempo)'), value: this.checkValue(summary.fuelRateByTime, 'L/h'), tooltip: this.$t('AppVehiclesTrack.Consumo de combustível em modo Deslocando sobre tempo de motor ligado em modo Deslocando')});
                    this.pushCard({title: this.$t('AppVehiclesTrack.Velocidade'), value: this.checkValue(summary.speed, 'km/h'), tooltip: this.$t('AppVehiclesTrack.Distância percorrida em modo Deslocando sobre tempo de motor ligado em modo Deslocando')});
                }
            },
            checkValue(val, medida) {
                if (!val || isNaN(val) || !isFinite(val) || val < 0) {
                    return 'N/D';
                } else if (medida === 'h') {
                    return formatHours(val);
                } else {
                    return val.toFixed(2) + ' ' + medida;
                }
            },
            pushCard(cardContent) {
                if (cardContent.value !== 'N/D') {
                    this.cards.push(cardContent);
                }
            },
            getHistoricalData(payload) {
                this.isLoadingSensorData = true;
                this.marker_historical = null;
                this.vehiclesService.getHistoricalData(payload)
                    .then((response) => {
                        this.historicalChartsData = response;
                        this.showFirstHistoricalMarker();
                    }).catch((error) => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehiclesTrack.Operação falhou'),
                        detail: this.$t('AppVehiclesTrack.Não foi possivel realizar a operação'),
                        life: 5000
                    });
                    console.log(error);
                }).finally(() => {
                    this.isLoadingSensorData = false;
                });
            },
            showFirstHistoricalMarker() {
                for (let i = 0; i < this.historicalChartsData.length; i++) {
                    let data = this.historicalChartsData[i].data;

                    if (!data) {
                        continue;
                    }

                    for (let j = 0; j < data.length; j++) {
                        if (!this.isLatLngValid(data[j])) {
                            continue;
                        }

                        this.marker_historical = {
                            lat: data[j].lat,
                            lng: data[j].lng
                        };
                        return;
                    }
                }
            },
            handleZoomChanged(payload) {
                this.mapBoundsAndZoom = payload;

                if (!this.showFields) {
                    return;
                }

                if (this.useFieldsTiles && this.fieldsOverlayActive === this.fieldsOverlayActiveOptions.DECK) {
                    // altera para os tiles
                    this.fieldsOverlayActive = this.fieldsOverlayActiveOptions.TILES;
                    this.getFieldsTiles();
                    this.$refs.googleMapsRealTime.removeFieldsFromRealTime();
                } else if (!this.useFieldsTiles && this.fieldsOverlayActive === this.fieldsOverlayActiveOptions.TILES) {
                    // alterar para o deck
                    this.fieldsOverlayActive = this.fieldsOverlayActiveOptions.DECK;
                    this.getFieldsDeck();
                    this.$refs.googleMapsRealTime.removeFieldsTiles();
                }
            },
            handleBoundsChanged(payload) {

                this.mapBoundsAndZoom = payload;

                if (!this.showFields) {
                    return;
                }

                //so preicisa gerenciar do deck pois os tiles são gerenciados pelo proprio gmaps
                if (this.fieldsOverlayActive === this.fieldsOverlayActiveOptions.DECK) {
                    this.getFieldsDeck();
                }
            },
            getDataToMapOverlay(){
                this.map_overlay_data = null
                let source = this.selectedVehicles.length > 0 ? this.selectedVehicles : this.vehicles;
                let vehiclesIds = [...new Set(source.map(v => v.id))];
                let organizationIds = [...new Set(source.map(v => v.organization_id))];

                if (vehiclesIds.length === 0 || organizationIds.length === 0) {
                    return
                }

                let params = new URLSearchParams()
                organizationIds.forEach(o => params.append("organizations", o))

                this.mapOverlayService.getMapOverlay(params, vehiclesIds)
                    .then(response => {
                        this.map_overlay_data = response
                    }).catch(() => {
                        this.map_overlay_data = null
                    })
            },
            getDataToMapOverlayByLme(response){
                let fleet_status = {
                    active: 0,
                    inactive: 0,
                    stop: 0,
                    maintenance: 0,
                    total: this.vehiclesSliced.length
                };
                let idle_machines = [];
                let fuel_level = [];
                let maintenance_machines = [];

                if(!response || response.length === 0){
                    return
                }

                this.addFuelLevelToVehicles(response);

                let vehiclesInMaintenance = this.getVehiclesInMaintenanceField(response);

                for (let i = 0; i < response.length; i++) {
                    let val = response[i];
                    let ts = this.isInSeconds(val._005) ? val._005 * 1000 : val._005;
                    let fleet = this.vehiclesSliced.find(v => v.id === val.id)?.identification;

                    if (val.is_unavailable) {
                        continue;
                    }

                    if (!ts || !moment(ts).isValid() || moment().diff(moment(ts), 'seconds') > 120) {
                        if (val._787 === 5 && (moment().diff(moment(ts), 'hours') <= 24)) {
                            fleet_status.stop++
                        } else {
                            fleet_status.inactive++
                        }

                        if(!val.id || !vehiclesInMaintenance || !vehiclesInMaintenance.has(val.id)){
                            continue
                        }

                        maintenance_machines.push({
                            fleet: fleet
                        })
                        fleet_status.maintenance++
                        continue
                    }

                    if (val._787 != 5) {
                        fleet_status.active++
                    }

                    if(val._058 != undefined && val._058 != null && val._058 <= 30 && val._058 >= 1){
                        fuel_level.push({
                            fleet: fleet,
                            level: val._058
                        })
                    }

                    if(val.id && vehiclesInMaintenance && vehiclesInMaintenance.has(val.id)){
                        maintenance_machines.push({
                            fleet: fleet
                        })
                        fleet_status.maintenance++
                        if(val._787 === 5){
                            fleet_status.stop++
                        }
                        continue
                    }

                    if(val._787 === 2 && val._1010040 && val._1010040 >= 120){
                        idle_machines.push({
                            fleet: fleet,
                            seconds: val._1010040,
                            time: formatSecondsAsHours(val._1010040)
                        })
                    }

                    if(val._787 === 5){
                        fleet_status.stop++
                    }
                }

                if(fleet_status.active + fleet_status.stop + fleet_status.inactive != fleet_status.total){
                    fleet_status.inactive = fleet_status.total - fleet_status.active - fleet_status.stop
                }

                this.fuel_level = fuel_level.sort((a, b) => a.level - b.level);
                this.fleet_status = fleet_status;
                this.idle_machines = idle_machines.sort((a, b) => b.seconds - a.seconds);
                this.maintenance_machines = maintenance_machines;
            },
            addFuelLevelToVehicles(lmeResponse) {
                this.vehicles.forEach(vehicle => {
                    let lmeData = lmeResponse.find(lme => lme.id === vehicle.id);
                    if (lmeData && lmeData._058 != null) {
                        vehicle.fuel_level = lmeData._058;
                    } else {
                        vehicle.fuel_level = null;
                    }
                });
            },
            getVehiclesInMaintenanceField(response){
                if(this.fieldsOverlayData.length === 0){
                    return new Set();
                }

                let vehiclesInMaintenanceField = new Set();

                let maintenanceFields = new Set(
                    this.fieldsOverlayData
                        .filter(field => field.type === 'MAINTENANCE')
                        .map(field => field.id)
                );

                let seen = new Set();
                let request = response
                    .filter(v => v.fields_ids != null)
                    .map(v => {
                        let match = v.fields_ids.match(/\[(.*?)\]/);
                        let list = match ? match[1].split(',').map(s => s.trim()) : [];
                        return { vid: v.id, fields: list };
                    })
                    .filter(v => {
                        if (seen.has(v.vid)) return false;
                        seen.add(v.vid);
                        return true;
                    });

                request.forEach(element => {
                    let hasMaintenanceField = element.fields.some(fieldId => maintenanceFields.has(fieldId));
                    if (hasMaintenanceField) {
                        vehiclesInMaintenanceField.add(element.vid);
                    }
                });

                return vehiclesInMaintenanceField
            },
            getFieldsToMapOverlay(response, vehiclesSliced) {
                if (!this.selectedOrganizations || this.selectedOrganizations.length === 0) {
                    return;
                }

                this.allLmeResponse = response;
                this.vehiclesSliced = vehiclesSliced;

                let params = {
                    swLat: this.mapBoundsAndZoom.sw_lat,
                    swLng: this.mapBoundsAndZoom.sw_lng,
                    neLat: this.mapBoundsAndZoom.ne_lat,
                    neLng: this.mapBoundsAndZoom.ne_lng,
                };

                const promises = [];
                let vm = this;

                this.selectedOrganizations.forEach(function (organizationId) {
                    promises.push(vm.fieldsService.getFieldsV3(organizationId.id, params));
                });

                Promise.all(promises)
                    .then((responses) => {
                        let allFields = [];

                        responses.forEach((responseData) => {
                            if (responseData && responseData.fields && responseData.fields.length > 0) {
                                allFields.push(...responseData.fields);
                            }
                        });

                        this.fieldsOverlayData = allFields;
                    }).catch((error) => {
                        console.log(error)
                    }).finally(() => {
                        this.getDataToMapOverlayByLme(response)
                        this.getDataToMapOverlay()
                    });
            },
            startVehiclesUpdater() {
                if (this.vehiclesUpdateInterval) {
                    return
                }

                this.vehiclesUpdateInterval = setInterval(() => {
                    this.vehiclesUpdater()
                }, 180000); // 3 minutos
            },
            stopVehiclesUpdater() {
                if (this.vehiclesUpdateInterval) {
                    clearInterval(this.vehiclesUpdateInterval);
                    this.vehiclesUpdateInterval = null;
                    this.map_overlay_data = null;
                }
            },
            vehiclesUpdater() {
                let request = [];
                let vehicles = this.vehicles;

                vehicles.forEach(vehicle => {
                    let info = {
                        vin: vehicle.identification_number,
                        mac_address: vehicle.mac_address,
                        vid: vehicle.id,
                        org_id: vehicle.organization_id,
                        lme_version: this.showMapOverlay ? 8 : 1,
                        expiration_time: 10000,
                        frequency: 2000
                    };
                    request.push(info);
                })

                this.realtimeService.requestDataLme(request)
                    .then((response) => {
                        let newResponse = this.removeOldLmes(response)
                        this.getFieldsToMapOverlay(newResponse, vehicles)
                    }).catch((error) => {
                        console.log(error);
                    })
            },
            updatedAllLmeResponse(response){
                let updatedLmeResponse = [...this.allLmeResponse];

                response.forEach(item => {
                    let index = updatedLmeResponse.findIndex(el => el.id === item.id);

                    if (index !== -1) {
                        updatedLmeResponse[index] = item;
                    } else {
                        updatedLmeResponse.push(item);
                    }
                });

                this.allLmeResponse = updatedLmeResponse;
                this.getDataToMapOverlayByLme(this.allLmeResponse);
            },
            removeOldLmes(response){
                let newResponse = []
                response.forEach(item => {
                    let chartsItem = this.realtimeChartsData.find(el => el.id === item.id);
                    let markerItem = this.realtimeDataMarkers.find(el => el.id === item.id);

                    if(!chartsItem || !markerItem || !chartsItem._005 || !markerItem._005 || !item._005){
                        newResponse.push(item);
                        return
                    }

                    if (chartsItem._005 > item._005 || markerItem._005 > item._005) {
                        return
                    }
                    newResponse.push(item);
                })
                return newResponse;
            }
        },
        components: {
            AppFilterBar, Splitpanes, Pane, AppGoogleMapsRealTime, Button,
            AppButton, AppVehiclesSelectVehicles, AppDateTimeControlBar,
            Dropdown, AppGoogleMapsLegend, MultiSelect, AppChartsRightSide, AppHistoricalMapOverlay, Dialog,
            AppGoogleMapsTypeControl, AppGoogleMapsWeatherLegend, AppVehiclesStatusControl, AppVehiclesNewSelectionDialog,
            AppRealTimeReport, AppDashboardMapOverlay
        },
        computed: {
            useFieldsTiles: function () {
                return this.mapBoundsAndZoom.zoom <= 14;
            },
            selectedOrganizationIdentification: function () {
                return this.selectedOrganizations[0] ? this.selectedOrganizations[0].id : 'undefined';
            },
            selectedOrganizationId: function () {
                return this.selectedOrganizations[0] ? this.selectedOrganizations[0].id : 'undefined';
            },
            organizationSelected: function () {
                if (!this.selectedOrganizations || this.selectedOrganizations.length === 0) {
                    return null
                }
                return this.selectedOrganizations[0].document_number;
            },
            isLoadingHistoricalData: function () {

                if (this.isLoadingTiles) {
                    return true;
                }

                if (this.isLoadingSensorData) {
                    return true;
                }

                if (this.isLoadingEvents) {
                    return true;
                }

                return false;
            },
            isScreenMobile: function() {
                return window.screen.width <= 1024;
            }
        },
        watch: {
            selectedVehicles: function (val) {
                if(this.showMapOverlay){
                    this.getDataToMapOverlay()
                }

                if (val && val.length > 0 && !this.showPanelStatus) {
                    this.showRightPaneCharts = true;
                } else {
                    this.showRightPaneCharts = false;
                }
            },
            selectedOrganizations: function(val){
                if(this.showMapOverlay){
                    this.getDataToMapOverlay()
                }

                if(!val || val.length === 0){
                    this.stopVehiclesUpdater();
                }

                if(val.length == 0 && this.showPanelStatus){
                    this.handleShowDetails();
                }

                if(val.length === 0 && this.showMapOverlay){
                    this.fuel_level = []
                    this.fleet_status = null
                    this.idle_machines = []
                    this.maintenance_machines = []
                }
            },
            vehicles: function (val) {
                if(val){
                    this.displayIdVehicles = [];
                    val.forEach(element => {
                        this.displayIdVehicles.push({ display_id: element.display_id, id: element.id });
                    });
                }
            }
        },
        beforeDestroy: function () {
            this.cancelRequestsRealTime();
            window.removeEventListener('keydown', this.keyF11);
        }
    }
</script>

<style scoped lang="scss">

    @import "../../../assets/styles/constants";

    //toda a altura subtraindo o menu superior
    .splitpanes-height {
        height: calc(100vh - 81px)
    }

    .splitpanes--vertical > .splitpanes__splitter {
        width: 3px !important;
    }

    .kt-portlet {
        margin-bottom: 0 !important;
    }

    .font-select-option {
        font-size: 15px;
    }

    .width-auto {
        width: auto !important;
    }

    .width-auto-100 {
        width: 100%;
    }

    .chart {
        height: calc(25vh - 53px);
        width: 100%;
    }

    .chart-pie {
        height: calc(50vh - 73px);
        width: 100%;
    }

    .cards-timeline {
        height: calc(100vh - 113px);
        width: 100%;
    }

    .wraper .google-maps {
        height: calc(100vh - 81px) !important;
    }

    .font-select-option {
        font-size: 15px;
    }

    .auto-center {
        margin-top: auto !important;
        margin-bottom: auto !important;
    }

    select:disabled {
        opacity: 0.6;
    }

    .multiselect-status-icon {
        padding: .25rem .5rem;
        height: 4vh;
    }

    .line {
        background-color: white;
        height: 35px;
        width: 35px;
        border-radius: 5px;
    }

    .item img {
        max-width: 35px;
    }

    .active{
        background-color: #1B6AEC;
    }

    .item-active img{
        max-width: 35px;
        filter: brightness(0%) invert(100%);
    }

    .position-bottom{
        position: absolute;
        z-index: 5;
        bottom: -25px;
        width: 95%;
        margin: 0 auto;
    }

    .height-maps{
        height: 65vh;
    }

    .height-maps-open{
        height: calc(100vh - 110px);
    }

    .height-maps-close{
        height: 65vh;
    }

    .active-panel{
        background-color: black;
    }

    .icon-eye{
        font-size: 22px;
        margin-top: 6px;
        margin-left: 6px;
    }

    .manual-download-button {
        background-color: $btn-primary-background-color;
        color: $btn-primary-text-color;
    }

    .button-graphics {
        width: 40px;
        height: 40px;
        margin: auto -20px;
        border-radius: 10px;
    }

    .button-graphics:hover {
        cursor: pointer;
    }

    .icon-graphic {
        font-size: 22px !important;
        margin-top: 8px;
        color: white;
    }

    @media(min-width: 1025px){
        .active:hover{
            background-color: #1757bd;
        }

        .icon-eye:hover{
            filter: brightness(80%);
        }

        .button-graphics:hover .icon-graphic{
            filter: brightness(90%);
        }

        .item img:hover {
            filter: brightness(80%);
        }
    }

    @media(max-width: 1024px){
        .position-bottom{
            bottom: 10px;
        }

        .button-graphics {
            width: 36px;
            height: 36px;
            margin: auto 6px;
        }

        .icon-graphic {
            font-size: 18px !important;
            margin-top: 9px;
            margin-left: 2px;
        }
    }
</style>
